import CardSystem from '../CardSystem';
import { ICardStateTaskData } from '../../../State/Card/ICardState';
import { AnimationClipTask } from 'Utility/Task/AnimationClipTask';
import { ReceivePlinkoCard } from 'System/Animation/Clip/ReceivePlinkoCard';

export default async function ReceivePlinkoCardAnimation(
    system: CardSystem,
    taskData: ICardStateTaskData
): Promise<void> {
    const plinkoCard = system.getCardByID(taskData.cards[0]);
    system.taskQueue.queue(
        new AnimationClipTask(
            new ReceivePlinkoCard(
                plinkoCard,
                {
                    system
                }
            ),
            true
        )
    );
}
